module.exports = __webpack_public_path__ + "static/media/bilista_logo_vertical.6381bd34.svg";